import CommitmentModal from './CommitmentModal';

export default CommitmentModal;
